import Home from './src/home.vue'
import MaterialManagement from './src/MaterialManage/MaterialManagement.vue'
import MaterialInfo from './src/MaterialManage/MaterialInfo.vue'
import FileManage from './src/MaterialManage/FileManagement.vue'
import FileList from './src/MaterialManage/FileList.vue'
import FileInfo from './src/MaterialManage/FileInfo.vue'
import ProjectData from './src/MaterialManage/ProjectData.vue'
import ProjectManagement from './src/ProjectTasks/ProjectManagement.vue'
import ProjectInfo from './src/ProjectTasks/ProjectInfo.vue'

import ProjectTaskInfo from './src/ProjectTasks/ProjectTaskInfo.vue'
import ProjectTaskManagement from './src/ProjectTasks/ProjectTaskManagement.vue'
let views = {
    Home,
    MaterialInfo,
    MaterialManagement,
    FileManage,
    ProjectData,
    FileList,
    FileInfo,
    ProjectManagement,
    ProjectInfo,
    ProjectTaskInfo,
    ProjectTaskManagement
};

export default views;